import { React } from "react";
import NumberFormat from "react-number-format";
import numeral from "numeral";

const AmountsFields = ({article, type, jsonCurrency, refCurrency, onArticleChange}) => {

  return (
    <>
      <NumberFormat
        data-testid={"AmountsFields"}
        displayType={"input"}
        thousandSeparator={"."}
        decimalSeparator={","}
        className="conti-contabili-credit"
        style={{background: "#def0f7"}}
        placeholder="-"
        suffix={" " + (jsonCurrency?.[refCurrency || "EUR"]?.symbol || "€")}
        value={
          type === "debit" ? article?.debit !== 0
            ? numeral(Math.abs(article?.debit)).format("0,0.00")
            : "" : article?.credit !== 0
            ? numeral(Math.abs(article?.credit)).format("0,0.00")
            : ""
        }
        onBlur={e => onArticleChange(type, e.target.value
          ? parseFloat(e.target.value.replace(".", "").replace(",", "."))
          : 0)
        }
      />
    </>
  );

};

export default AmountsFields;
